import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import EventIcon from '@material-ui/icons/Event';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useStyles } from "components/layout/CommonStyles";
import { useTranslation } from "react-i18next";
import CloseIcon from '@material-ui/icons/Close';
import Buttons from "components/buttons/Pressed";
import Grid from "@material-ui/core/Grid";
import Input from "components/inputs/Input";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { dateValidation } from "../../../../../utils/validation/DateValidation";
import { dateToBR } from "utils/dates/DateToBRr";

const DialogDateVacation = props => {
    const classes = useStyles();
    const [t] = useTranslation();
    const { open, setOpen, context, holidayDate, justification, oldHolidayDate, newHolidayDate, rulesetId, userId, setParentValues, setHasChange } = props;

    const [values, setValues] = useState({
        holidayDate: null,
        justification: "",
    });

    const [requiredHolidayDate, setRequiredHolidayDate] = useState(false);
    const [invalidDateHoliday, setInvalidDateHoliday] = useState(false);


    useEffect(() => {
        setValues({
            ...values,
            holidayDate: holidayDate ? holidayDate : null,
            justification: justification ? justification : "",
        });
    }, [holidayDate, justification]);

    const clearDialog = () => {
        setRequiredHolidayDate(false);
        setInvalidDateHoliday(false);
        setValues({
            ...values,
            holidayDate: holidayDate ? holidayDate : null,
            justification: justification ? justification : "",
        });
    }

    const handleClose = () => {
        setOpen(false);
        clearDialog();

    }

    const handleChange = name => e => {
        setHasChange(true);
        setRequiredHolidayDate(false);
        setInvalidDateHoliday(false);
        setValues({ ...values, [name]: e })
    }
    const handleJustification = (name, value) => {
        setValues({ ...values, [name]: value })
    }

    const verifySubmit = () => {
        let res = true;
        if (values.holidayDate === null && (rulesetId === 6908851 || rulesetId === 6909001)) {
            res = false;
            setRequiredHolidayDate(true);
        }
        if (!dateValidation(values.holidayDate) && (rulesetId === 6908851 || rulesetId === 6909001)) {
            res = false;
            setInvalidDateHoliday(true)
        }

        return res;
    }

    const handleSubmit = () => {
        const canSubmit = verifySubmit();
        if (canSubmit) {
            setParentValues(old => ({
                ...old,
                holidayDate: values.holidayDate,
                holidayDateJustification: values.justification
            }));
            setOpen(false);
        }
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle className={classes.Title}>
                <b>{context === "view" ? t("GENERAL.view") + " " + t("HR.baseDateForVacation") : t("HR.editHolidayDate")}</b>
                <IconButton style={{ float: "right", marginTop: -10, marginRight: -17 }} edge="end" color="inherit" onClick={handleClose} aria-label="close">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container item spacing={2} md={12} lg={12}>
                    <Grid item xs={12} sm={12}>
                        <Input
                            disabled
                            label={"HR.oldHolidayDate"}
                            value={oldHolidayDate ? dateToBR(new Date(oldHolidayDate)) : ""}
                            valueName={"oldHolidayDate"}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton disabled>
                                            <EventIcon />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        {context === "view" ?
                            <Input
                                disabled
                                required
                                label={"HR.newHolidayDate"}
                                value={newHolidayDate ? dateToBR(new Date(newHolidayDate)) : ""}
                                valueName={"newHolidayDate"}
                            /> :
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    disabled={context === "view"}
                                    className={classes.identificationDatePicker}
                                    error={requiredHolidayDate || invalidDateHoliday}
                                    helperText={requiredHolidayDate ? t("GENERAL.requiredField") : invalidDateHoliday ? t("GENERAL.invalidDate") : ""}
                                    disableToolbar
                                    autoOk={true}
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    id="validity"
                                    margin="normal"
                                    invalidDateMessage=""
                                    label={t("HR.newHolidayDate") + ((rulesetId === 6908851 || rulesetId === 6909001) ? "*" : "")}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date"
                                    }}
                                    value={values.holidayDate}
                                    onChange={handleChange("holidayDate")}
                                />
                            </MuiPickersUtilsProvider>}
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <Input
                            context={context}
                            label={"GENERAL.justification"}
                            value={values.justification}
                            valueName={"justification"}
                            rows={5}
                            maxLength={200}
                            handleChange={handleJustification}
                        />
                    </Grid>

                </Grid>
            </DialogContent>
            <DialogActions>
                <Buttons
                    onClick={handleClose}
                    tipo="BN-noback"
                    conteudo={context === "view" ? t("GENERAL.close").toUpperCase() : t("GENERAL.cancel").toUpperCase()}
                />
                {context !== "view" ?
                    <Buttons
                        onClick={handleSubmit}
                        tipo="BN-blue"
                        conteudo={t("GENERAL.update").toUpperCase()}
                    />
                    : null}
            </DialogActions>
        </Dialog>
    )
}

export default DialogDateVacation;
